import React from 'react';
import {Container, Divider, Typography} from "@material-ui/core";
import RequestPasswordForm from "./RequestPasswordForm";
import {useTranslation} from "react-i18next";
import queryString from "query-string";
import {useLocation} from "react-router-dom";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import DoneIcon from "@material-ui/icons/Done";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoPageComponents from "../core/auth/InfoPageComponents";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        divider: {
            margin: 30
        }
    })
);

const RequestPasswordSuccessComponents = () => {
    return <InfoPageComponents caption="form.request-password.success.submitted"
                               icon={<DoneIcon/>}
                               infoMessages={["form.request-password.success.email-sent",
                                   "form.request-password.success.further-info"]}
    />;
};

const RequestPasswordErrorComponents = () => {
    const { state } = useLocation();
    const message = state?.message ?? "An error occurred";

    return <InfoPageComponents caption={message} icon={<InfoOutlinedIcon/>}/>;
};

const RequestPasswordComponents = () => {
    const {t} = useTranslation();
    const classes = useStyles();

    return (
        <>
            <Typography>
                {t("form.request-password.caption")}
            </Typography>

            <RequestPasswordForm/>

            <Divider className={classes.divider}/>

            <Typography variant={"body2"}>
                {t("form.request-password.info")}
            </Typography>
        </>
    )
};

const RequestPasswordPageComponents = () => {
    const {search} = useLocation();
    const {success} = queryString.parse(search);

    return (
        <Container maxWidth={"xs"}>
            {(() => {
                switch (success) {
                    case "true":
                        return <RequestPasswordSuccessComponents/>;
                    case "false":
                        return <RequestPasswordErrorComponents/>;
                    default:
                        return <RequestPasswordComponents/>;
                }
            })()}
        </Container>
    )
};

export default RequestPasswordPageComponents;